import { Modal, Button, Form, message } from 'antd';
import { useCreateExcepcion } from '../api/useExcepciones';
import { useT } from '../../../locales';
import { ExcepcionForm } from './ExcepcionForm';

interface ExcepcionCreateModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  preselectedClienteId?: number;
}

export function ExcepcionCreateModal({
  open,
  onClose,
  onSuccess,
  preselectedClienteId,
}: ExcepcionCreateModalProps) {
  const t = useT();
  const [form] = Form.useForm();
  const createExcepcion = useCreateExcepcion();

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      await createExcepcion.mutateAsync(
        values as Parameters<typeof createExcepcion.mutateAsync>[0],
      );
      message.success(t('pages.excepciones.createSuccess'));
      onClose();
      onSuccess?.();
    } catch {
      message.error(t('pages.excepciones.createError'));
    }
  };

  return (
    <Modal
      title={t('pages.excepciones.create')}
      open={open}
      onCancel={onClose}
      destroyOnHidden
      centered
      width={640}
      rootClassName="excepcion-create-modal"
      styles={{ body: { maxHeight: 'min(75vh, 675px)', overflowY: 'auto' } }}
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t('common.cancel')}
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={createExcepcion.isPending}
          onClick={() => form.submit()}
        >
          {t('pages.excepciones.create')}
        </Button>,
      ]}
    >
      <ExcepcionForm
        mode="create"
        form={form}
        hideSubmit
        onSubmit={handleSubmit}
        loading={createExcepcion.isPending}
        preselectedClienteId={preselectedClienteId}
      />
    </Modal>
  );
}
